// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border[data-v-99327cd4]{border-bottom:1px solid #edeeee}.numberOfImages[data-v-99327cd4]{position:absolute;top:38%;color:#fff;left:43%}.overlay[data-v-99327cd4]{background:linear-gradient(0deg,rgba(0,0,0,.3),rgba(0,0,0,.3))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
